import { routes } from '@/lib/constants';

/** Routes where 401 should not wipe the session or hard-redirect (onboarding in progress). */
export const isProtectedOnboardingRoute = (pathname: string): boolean =>
  pathname.startsWith(routes.signUp);

/** Auth shell routes (login, sign-up, forgot password). */
export const isAuthShellRoute = (pathname: string): boolean =>
  pathname.startsWith(routes.login) ||
  pathname.startsWith(routes.signUp) ||
  pathname.startsWith(routes.forgotPassword);
